export const MEDICAL_CODE_LABEL = 'کدنظام پزشکی';
export const MEMBERSHIP_NUMBER_LABEL = 'شماره عضویت';

const escapeHtml = (value: string): string =>
  value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

export const formatCouncilMedicalCodeLine = (code: string, label: string = MEDICAL_CODE_LABEL): string =>
  `${label}: ${code.trim()}`;

export const resolveCouncilMedicalCode = (...candidates: Array<string | number | null | undefined>): string => {
  for (const candidate of candidates) {
    if (typeof candidate === 'number' && Number.isFinite(candidate)) {
      return String(candidate);
    }
    if (typeof candidate === 'string' && candidate.trim()) {
      return candidate.trim();
    }
  }
  return '';
};

/** Removes system-owned code lines («کدنظام پزشکی» / «شماره عضویت») from biography HTML so they are not shown as editable copy. */
export const stripCouncilMedicalCodeFromBiography = (biography: string | null | undefined): string => {
  if (typeof biography !== 'string' || !biography) {
    return '';
  }

  return biography.replace(/<p>\s*(?:کدنظام پزشکی|شماره عضویت):\s*[^<]*<\/p>/gi, '').trim();
};

/** Prepends the code line («کدنظام پزشکی: …» / «شماره عضویت: …») to about-me HTML without mutating SEO biography. */
export const buildAboutBiographyWithMedicalCode = (
  biography: string | null | undefined,
  medicalCode: string | null | undefined,
  label: string = MEDICAL_CODE_LABEL,
): string => {
  const code = resolveCouncilMedicalCode(medicalCode);
  const bio = stripCouncilMedicalCodeFromBiography(biography);
  if (!code) {
    return bio;
  }

  const line = formatCouncilMedicalCodeLine(code, label);
  const paragraph = `<p>${escapeHtml(line)}</p>`;
  return bio ? `${paragraph}${bio}` : paragraph;
};
